import type { VFC } from 'react'
import { Size } from '@opallabs/gem'
import { useTheme } from '@opallabs/hooks'
import { kuiperClassNames } from '@opallabs/kuiper'
import { Button, ButtonIconPosition, Icon } from '@opallabs/lapidary'
import * as styles from './styles'
import type { AddStageButtonProps } from './types'

export const AddStageButton: VFC<AddStageButtonProps> = ({
  className,
  disabled,
  label = 'Add Phase',
  onClick,
  onDarkBackground,
  theme = 'light',
}) => {
  const currentTheme = useTheme()
  const isDark = onDarkBackground ?? currentTheme === 'dark'

  return (
    <Button
      className={kuiperClassNames(['addStageButton', className])}
      disabled={disabled}
      icon={
        <Icon ariaHidden glyph="gem-add" height={Size.Icon} width={Size.Icon} />
      }
      iconPosition={ButtonIconPosition.trailing}
      buttonText={label}
      variant="ghost"
      name="add-stage"
      onClick={onClick}
      overrideStyles={styles.buttonOverrides(isDark)}
      theme={theme}
    />
  )
}

AddStageButton.displayName = 'Plasma: AddStageButton ← StageList ← Workflow'
